import { useTranslation } from 'react-i18next';
import { Typography } from '@ui/components';
import { FC } from 'react';

export const FieldsList: FC = () => {
  const { t } = useTranslation();

  return (
    <section className="grid grid-cols-2 gap-4">
      <div>
        <Typography variant="paragraphBasicBook" element="p">
          {t('ONBOARDING.IMPORT_MODAL.VEHICLES_FIELDS')}
        </Typography>

        <ul className="list-disc list-inside mt-3 space-y-1">
          <Typography variant="paragraphBasicBook" element="li">
            {t('ONBOARDING.IMPORT_MODAL.VEHICLES_FIELDS_REGISTRATION_NUMBER')}
          </Typography>

          <Typography variant="paragraphBasicBook" element="li">
            {t('ONBOARDING.IMPORT_MODAL.VEHICLES_FIELDS_REGISTRATION_COUNTRY')}
          </Typography>

          <Typography variant="paragraphBasicBook" element="li">
            {t('ONBOARDING.IMPORT_MODAL.VEHICLES_FIELDS_CATEGORY')}
          </Typography>

          <Typography variant="paragraphBasicBook" element="li">
            {t('ONBOARDING.IMPORT_MODAL.VEHICLES_FIELDS_NAME')}
          </Typography>

          <Typography variant="paragraphBasicBook" element="li">
            {t('ONBOARDING.IMPORT_MODAL.VEHICLES_FIELDS_LABELS')}
          </Typography>
        </ul>
      </div>

      <div>
        <Typography variant="paragraphBasicBook" element="p">
          {t('ONBOARDING.IMPORT_MODAL.EMPLOYEES_FIELDS')}
        </Typography>

        <ul className="list-disc list-inside mt-3 space-y-1">
          <Typography variant="paragraphBasicBook" element="li">
            {t('ONBOARDING.IMPORT_MODAL.EMPLOYEES_FIELDS_FIRST_NAME')}
          </Typography>

          <Typography variant="paragraphBasicBook" element="li">
            {t('ONBOARDING.IMPORT_MODAL.EMPLOYEES_FIELDS_LAST_NAME')}
          </Typography>

          <Typography variant="paragraphBasicBook" element="li">
            {t('ONBOARDING.IMPORT_MODAL.EMPLOYEES_FIELDS_PHONE_NUMBER')}
          </Typography>

          <Typography variant="paragraphBasicBook" element="li">
            {t('ONBOARDING.IMPORT_MODAL.EMPLOYEES_FIELDS_EMAIL')}
          </Typography>

          <Typography variant="paragraphBasicBook" element="li">
            {t('ONBOARDING.IMPORT_MODAL.EMPLOYEES_FIELDS_LABELS')}
          </Typography>

          <Typography variant="paragraphBasicBook" element="li">
            {t('ONBOARDING.IMPORT_MODAL.EMPLOYEES_FIELDS_ASSIGNED_VEHICLES')}
          </Typography>
        </ul>
      </div>
    </section>
  );
};
